export type ImageType = Pick<HTMLImageElement, 'src' | 'alt'>;

export const isImageProps = (imageProps: unknown): imageProps is ImageType =>
  typeof (imageProps as ImageType)?.src === 'string' && typeof (imageProps as ImageType)?.alt === 'string';
